import { SearchFilterDecorator, Decorator } from '@/types'
import { IconName } from '@/components/Icons'

export type SearchFilter = {
  decorator: SearchFilterDecorator,
  label: string
}

export const decoratorIcons: Record<Decorator["key"], IconName> = {
  BEST_SELLER: 'star',
  MOST_POPULAR: 'thumbsUp',
  SKIP_THE_QUEUE: 'stopwatch',
  SEASONAL: 'autumnLeaf',
  MEALS_INCLUDED: 'bell',
  HOTEL_PICKUP: 'bus',
  SELF_DRIVE: 'key',
  FREE_PARKING: 'parking',
  LOW_FITNESS_LEVEL: 'walking',
  MEDIUM_FITNESS_LEVEL: 'walking',
  HIGH_FITNESS_LEVEL: 'walking',
  LOW_ADRENALINE_LEVEL: 'gauge',
  MEDIUM_ADRENALINE_LEVEL: 'gauge',
  HIGH_ADRENALINE_LEVEL: 'gauge',
  ECO_NATURE_TOURISM: 'leaf',
  ECO_TOURISM: 'leaf',
  ECO_ADVANCED_TOURISM: 'leaf',
  CLIMATE_ACTION_CERTIFIED: 'globeAustralia',
  ROC_CERTIFIED: 'holdingHeart',
  REDUCE_WASTE: 'reduceWaste',
  NO_SINGLE_PLASTIC: 'recycle',
  WHEELCHAIR_FRIENDLY: 'wheelchair',
  MOTORISED_WHEELCHAIR_FRIENDLY: 'wheelchair',
  ACCESSIBLE_PARKING_AREA: 'accessible',
  VISION_IMPAIRED_FRIENDLY: 'eye',
  HEARING_IMPAIRED_FRIENDLY: 'earDeaf',
  ASSISTANCE_DOG_FRIENDLY: 'shieldDog',
  HIDDEN_DISABILITY_FRIENDLY: 'flower'
}

export const searchFiltersDecorators: SearchFilter[] = [
  { decorator: 'HOTEL_PICKUP', label: 'Hotel pickup' },
  { decorator: 'BEST_SELLER', label: 'Best seller' },
  { decorator: 'MEALS_INCLUDED', label: 'Meals included' },
  { decorator: 'SKIP_THE_QUEUE', label: 'Skip the queue' },
  { decorator: 'WHEELCHAIR_FRIENDLY', label: 'Wheelchair friendly' },
]